import Dialog from '@luminopia/react-toolbox/lib/dialog'
import * as React from 'react'

/**
 * props for Confirm component
 */
export interface IProps {
  /** called when user has clicked Confirm */
  onConfirm: () => any
  /** called when user has cancelled the Confirm modal */
  onCancel: () => any
  /** content inside the Confirm modal */
  children?: any
  /** title of the Confirm modal */
  title?: string
  /** whether the Confirm modal is visible and interactable */
  active: boolean
}

/**
 * Component for displaying a Confirm modal for actions that need extra attention to ensure that the user
 * is certain that the action should be executed.
 */
class Confirm extends React.PureComponent<IProps, {}> {
  public render() {
    return (
      <Dialog
        actions={this.actions()}
        active={this.props.active}
        onEscKeyDown={this.props.onCancel}
        onOverlayClick={this.props.onCancel}
        title={this.props.title}
      >
        {this.props.children}
      </Dialog>
    )
  }

  private actions = () => {
    return [
      {
        // TODO I18N
        label: 'Cancel',
        onClick: this.props.onCancel,
      },
      {
        // TODO I18N
        label: 'Confirm',
        onClick: this.props.onConfirm,
      },
    ]
  }
}

export default Confirm



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/confirm/index.tsx